import { connect } from 'react-redux';
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import { createSelector } from 'reselect';
import { updateEdits, clearEditWish } from 'store/editWish/actions';
import { getEditedWishId, getEditsForWishId } from 'store/editWish/selectors';
import { getEditedWish } from 'store/firebase/selectors';
import { getIsSmallScreen } from 'store/browser/selectors';
import EditWish from './EditWish';

const mapStateToProps = createSelector(
  getEditedWish,
  getEditedWishId,
  getEditsForWishId,
  getIsSmallScreen,
  (wish, wishId, edits, isSmallScreen) => ({
    wish, wishId, edits, open: !!wish, fullScreen: isSmallScreen
  })
);

const actions = (dispatch, { firebase }) => ({
  onChange: (field, value, wishId) => {
    const edits = { [field]: value }
    dispatch(updateEdits(wishId, edits));
  },
  onSave: (newValues, wishId) => {
    firebase.ref(`wishes/${wishId}`).set(newValues);
    dispatch(clearEditWish(wishId));
  },
  onCancel: wishId => {
    dispatch(clearEditWish(wishId));
  }
});

export default compose(
  firebaseConnect(props => ([
    `wishes/${props.wishId}`
  ])),
  connect(mapStateToProps, actions)
)(EditWish);



// WEBPACK FOOTER //
// ./src/components/dialogs/EditWish/index.js